var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.0202 16.4983L95.8581 11.0683C95.8581 11.0683 94.5337 8.54531 94.1302 8.00531C93.7267 7.46531 92.4802 6.31331 92.4802 6.31331H84.7191C84.7191 6.31331 82.6131 7.75631 82.4991 7.83431C82.3851 7.91231 60.4776 8.13581 60.4776 8.13581L60.0022 6.31331L55.6882 4.40981L52.0311 3.31781H32.0947L31.3896 3.70181H28.2081L27.2362 4.25081V6.36281L28.2081 7.12331L31.3761 7.29281V8.27081H27.2016L26.3226 9.14981L26.1396 12.3598L27.5331 13.2043H29.1801V14.6818L26.3226 14.8363V21.1858C26.3226 21.4813 27.7026 22.4533 27.7026 22.4533L44.4276 23.2483L46.2022 24.9868V28.8433L45.3157 29.9413L46.2022 31.4488L50.7637 45.5653L52.4106 47.8798L55.2741 48.8113L65.0947 48.4888C65.0947 48.4888 65.8072 51.6628 65.8477 51.8473C65.8897 52.0318 68.4307 51.3403 68.4307 51.3403L68.6107 51.8893L69.3877 54.2548L67.7137 54.7843V56.5348L69.3877 57.4213L81.4131 55.5208V53.6203L80.4546 49.0588L82.0581 46.5253L77.8732 29.9398L81.0471 23.0818L81.6502 22.4518C81.6502 22.4518 91.8652 21.1723 92.9197 20.9413C93.9742 20.7103 94.5006 19.6933 94.8441 18.6088C95.1876 17.5243 95.1081 16.4968 95.1081 16.4968H96.0202V16.4983ZM53.8866 46.3153L52.8171 45.3013C52.8171 45.3013 48.9321 31.8988 49.0446 31.7308C49.1571 31.5613 46.3416 22.8898 54.0561 21.8758H57.3786L58.1106 26.3803L57.0606 27.7888L55.1257 28.5208L55.6327 29.5903L57.9981 28.6888L62.1651 28.6318L65.4877 46.0318L53.8882 46.3138L53.8866 46.3153Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5908 9.61481L84.8023 11.2903V15.4843",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4775 9.61481L86.6875 11.2903V15.4843",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3635 9.61481L88.575 11.2903V15.4843",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.25 9.61481L90.4615 11.2903V15.4843",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1375 9.61481L92.3475 11.2903V15.4843",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0225 9.61481L94.234 11.2903V15.4843",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7223 19.9048C74.7223 19.9048 73.7653 25.0858 73.3138 26.3248C72.8638 27.5638 71.6803 30.1933 68.1328 30.3703C64.5853 30.5473 62.4958 30.3703 62.4958 30.3703",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0928 32.9129L67.7958 45.3584L71.2308 44.5694C71.2308 44.5694 73.7643 43.8944 73.3143 41.5844C72.8643 39.2759 71.7378 34.0949 71.7378 34.0949C71.7378 34.0949 70.9998 31.5614 68.6088 32.0684C66.2178 32.5754 65.0928 32.9129 65.0928 32.9129V32.9129Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.387 54.2563L81.4125 53.6218",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.209 3.70197V7.12347",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.137 19.3918C92.5686 19.3918 92.9185 19.0419 92.9185 18.6103C92.9185 18.1787 92.5686 17.8288 92.137 17.8288C91.7054 17.8288 91.3555 18.1787 91.3555 18.6103C91.3555 19.0419 91.7054 19.3918 92.137 19.3918Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.006 52.9468C72.2628 52.9468 72.471 52.7387 72.471 52.4818C72.471 52.225 72.2628 52.0168 72.006 52.0168C71.7492 52.0168 71.541 52.225 71.541 52.4818C71.541 52.7387 71.7492 52.9468 72.006 52.9468Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4199 3.32242H50.8899C50.8899 3.32242 53.6559 3.09742 60.0009 6.31342L60.2799 8.13592H82.0584L84.7194 6.31342H92.4804C92.4804 6.31342 95.0334 8.26342 96.0204 11.5574V16.4984H94.8549V18.3989C94.8549 18.3989 94.9209 20.5529 92.4804 21.0599C90.0399 21.5669 81.4134 22.4534 81.4134 22.4534L80.4549 24.1004L77.8719 29.9414L82.0569 46.5269L80.4534 49.0604L81.4119 53.6219V55.5224L69.3864 57.4229L67.7124 56.5364V54.7859L69.3864 54.2564L68.4279 51.3419L65.8449 51.8489L65.0769 48.4274C65.0769 48.4274 56.4609 48.6809 55.5744 48.8069C54.6879 48.9329 52.4064 47.8799 52.4064 47.8799L50.7594 45.5654L46.1979 31.4489L45.3114 29.9414L46.1979 28.8434V24.9869L44.4234 23.2484L27.6984 22.4534L26.3184 21.1859V14.8364L29.1759 14.8079V13.2029H27.5289L26.3184 12.8234V9.14842L27.1974 8.26942H31.3719V7.12192H28.2039L27.2319 6.65692V4.25092L28.2039 3.70192H31.4139V3.32242H31.4199Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4877 46.035L53.8867 46.317L52.8172 45.303C52.8172 45.303 48.9322 31.9005 49.0447 31.7325C49.1572 31.5645 46.3417 22.8915 54.0562 21.8775H57.3787L58.1107 26.382L57.0607 27.7905L55.1257 28.5225L55.6327 29.592L57.9982 28.6905L62.1652 28.6335L65.4877 46.0335V46.035Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3792 21.8759H63.2922V19.9049H74.7237C74.7237 19.9049 74.9487 19.116 76.1322 19.116H79.6242C79.6242 19.116 80.4687 18.7215 80.8632 19.7355C81.2577 20.7495 81.4152 22.4519 81.4152 22.4519",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4195 3.70197V13.149C31.4195 13.149 30.8 16.1895 35.3045 16.1895H46.511C46.511 16.1895 48.8765 16.02 49.5515 14.388C50.2265 12.7545 50.678 11.3475 53.4365 11.3475L60.476 11.2905V8.13747",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3545 11.436V16.752H77.484C77.484 16.752 77.8785 15.9075 78.948 15.9075C80.0175 15.9075 80.2995 16.8645 80.2995 17.484C80.2995 18.1035 80.0745 19.041 78.723 19.041",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1875 16.752V19.1175",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7385 16.752V18.6105H76.1875",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4766 11.2905H96.0206",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0583 8.13593H94.2324",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2979 16.7519H94.8553",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4294 51.3419L80.4549 49.0604",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4766 22.1024C60.6461 22.8914 60.4766 26.4944 60.4766 26.4944L60.9266 27.2834L62.1656 28.6349L63.7496 26.1284L63.2921 21.8774",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8125 17.9339H69.395",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8457 20.7465C55.3104 20.7465 55.6872 20.3697 55.6872 19.905C55.6872 19.4402 55.3104 19.0635 54.8457 19.0635C54.3809 19.0635 54.0042 19.4402 54.0042 19.905C54.0042 20.3697 54.3809 20.7465 54.8457 20.7465Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8238 14.0324C41.6423 14.0324 42.3058 13.3689 42.3058 12.5504C42.3058 11.7319 41.6423 11.0684 40.8238 11.0684C40.0053 11.0684 39.3418 11.7319 39.3418 12.5504C39.3418 13.3689 40.0053 14.0324 40.8238 14.0324Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnum);
export default __webpack_public_path__ + "static/media/Magnum.fdfe3e13b5d6019ae2d2895c9ed50772.svg";
export { ForwardRef as ReactComponent };